import { render, staticRenderFns } from "./FormAdicionarRelacaoCliente.vue?vue&type=template&id=c4a81a14"
import script from "./FormAdicionarRelacaoCliente.vue?vue&type=script&lang=js"
export * from "./FormAdicionarRelacaoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports